import * as React from 'react';

export function ArrowSmallLeftSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <title>{'159 arrow left small'}</title>
      <path d="M10.88 17.715a1 1 0 000-1.415l-3.292-3.293L18 13a1 1 0 000-2l-10.414.007 3.294-3.292A1 1 0 009.466 6.3L5.88 9.886a3 3 0 000 4.243l3.586 3.586a1 1 0 001.414 0z" />
    </svg>
  );
}
